import request from "@/utils/request";

export function getLotteryLogs(data) {
  return request({
    url: "/lottery/log/search/",
    method: "POST",
    data: data
  });
}

export function getLotteryResults(data) {
  return request({
    url: "/lottery/result/",
    method: "POST",
    data: data
  });
}
